import { render, staticRenderFns } from "./IdentifyPatient.vue?vue&type=template&id=b6b66576&scoped=true"
import script from "./IdentifyPatient.vue?vue&type=script&lang=js"
export * from "./IdentifyPatient.vue?vue&type=script&lang=js"
import style0 from "./IdentifyPatient.vue?vue&type=style&index=0&id=b6b66576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b66576",
  null
  
)

export default component.exports